module.exports = __webpack_public_path__ + "img/header_bg.767eab1a.png";